<template>
    <label :class="labelClass">
        <template v-if="$slots.text">
            <div>
                <slot name="text"></slot>
            </div>
        </template>
        <template v-else>
            <div :class="{'required': isRequired}">{{ text }}</div>
        </template>
        <span v-if="count !== null" :class="{'limits': isLimited}">
            {{ getFormattedValue(count) }}
            <template v-if="limit">
                / {{ getFormattedValue(limit) }}
            </template>
        </span>
    </label>
</template>

<script>
export default {
    name: "TemplatesLabelCounts",
    props: {
        text: {
            type: String,
            required: true,
        },
        count: {
            type: Number,
            required: false,
            default: null,
        },
        min: {
            type: Number,
            required: false,
            default: null,
        },
        limit: {
            type: Number,
            required: false,
            default: null,
        },
        labelClass: {
            type: String,
            required: false,
            default: null,
        },
        // вывод иконки для обязательного заполнения
        isRequired: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        isLimited() {
            return (
                (this.limit && this.count > this.limit)
                || (this.min && this.min > this.count)
            );
        }
    },
    methods: {
        getFormattedValue(value) {
            return value.formatMoney(0, ' ', ' ');
        },
    },
}
</script>

<style scoped>
label > div {
    display: inline-flex;
    align-items: center;
}
label {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}
label span {
    font-size: 0.625rem;
}
.limits {
    color: var(--red-500);
}
</style>
